export default __webpack_public_path__ + "static/blob6-62c0ebb6ffd7c9c9f677b90d284cd272.svg";